import InfoTooltip from "components/Popup/InfoTooltip";
import { IOption } from "Dashboard/domain/IOption";
import ProjectSelect from "Dashboard/scenes/Projects/components/ProjectSelect";
import { useCallback, useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import { BsPrinterFill } from "react-icons/bs";
import customStyles from "../../Main/components/SelectStyle";
import { DateRange } from "Dashboard/scenes/Carnets/domain/DateRange";
import EmployeeSelect from "Dashboard/scenes/Resources/components/EmployeeSelect";
import { BiSearchAlt } from "react-icons/bi";
import { ICarentsTotals } from "Dashboard/scenes/Carnets/domain/ICarnetsTotals";

interface IProps {
  selectDate: (data: DateRange) => void;
  selectedDateFrom: string | undefined;
  selectedDateTo: string | undefined;
  selectProject: (projectId: number) => void;
  selectEmployee: (employeeId: number) => void;
  projects: IOption[];
  totals: ICarentsTotals;
  print: Function;
}

const CarnetsHeader = ({
  selectDate,
  selectedDateFrom,
  selectedDateTo,
  projects,
  selectProject,
  selectEmployee,
  totals,
  print
}: IProps) => {

  const [dateRange, setDateRange] = useState
    <[Date | undefined, Date | undefined]>
    ([selectedDateFrom ? new Date(selectedDateFrom) : undefined,
    selectedDateTo ? new Date(selectedDateTo) : undefined]);
  const [startDate, endDate] = dateRange;

  const selectDateRange = useCallback((dates: Date[]) => {
    const [date0, date1] = dates;

    if (date0 && date1) {
      selectDate({ dateFrom: date0, dateTo: date1 });
    }
    if (!date0 && !date1) {
      selectDate({ dateFrom: undefined, dateTo: undefined });
    }
  }, [selectDate]);

  useEffect(() => {
    selectDateRange(dateRange as Date[]);
  }, [dateRange, selectDateRange]);

  return (
    <div
      className="row"
      style={{ "--carnet-hour-columns": totals.hoursTotals.length } as React.CSSProperties}
    >
      <div className="col"></div>
      <div className="col start karneti-header-cell">
        <label>KARNETI</label><label>(redom)</label>
        <div className="employee-select-container">
          <EmployeeSelect
            onChange={selectEmployee}
            customStyles={customStyles}
            placeholder={
              <><BiSearchAlt size={12} /><span>Zaposleni</span></>
            }
          />
        </div>
      </div>
      <div className="col lowercase center separatorLine">Datum</div>
      {totals.hoursTotals.map(totalsItem =>
        <div className="col lowercase center separatorLine"
          key={totalsItem.index}
        >
          {totalsItem.label}
        </div>
      )}
      <div className="col lowercase center separatorLine">Obrok</div>
      <div className="col lowercase center separatorLine">Keš obrok</div>
      <div className="col lowercase center separatorLine">Bolovanje</div>
      <div className="col lowercase center separatorLine">Odmor</div>
      <div className="col center separatorLine">
        <ProjectSelect
          options={projects}
          onChange={(projectId: number) => {
            selectProject(projectId);
          }}
          placeholder={
            <><BiSearchAlt size={12} /><span>Projekat</span></>
          }
          defaultValue={0}
          customStyles={customStyles}
        />
      </div>
      <div className="col strong">
        <div className="dateRange">
          <ReactDatePicker
            selectsRange={true}
            startDate={startDate}
            endDate={endDate}
            showMonthDropdown
            showYearDropdown
            dateFormat="dd.MM.yy"
            onChange={(update: any) => {
              setDateRange(update);
            }}
            isClearable={true}
          />
        </div>
      </div>

      <InfoTooltip
        tooltip="Štampa karneta"
        classesProp="col print-carnet-button"
        onClick={() => print()}>
        <BsPrinterFill size={15} color="#B8B8B8" style={{ marginTop: "2px" }} />
      </InfoTooltip>

    </div>
  );
};

export default CarnetsHeader;
